var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.$t(_vm.content)),expression:"$t(content)"}]})}
var staticRenderFns = []

export { render, staticRenderFns }